import React from "react";

const Admin = () => <h1>Hello, World!</h1>;

export default Admin;
